export default {
  LIVE: 'L',
  SUSPENDED: 'S',
  INACTIVE: 'I'
}
